const PADDLE_COLOR_VARIANTS = [
  ["red", "Red"],
  ["blu", "Blue"],
  ["grn", "Green"],
  ["ylw", "Yellow"],
  ["ltblu", "Light Blue"],
  ["pink", "Pink"],
  ["purple", "Purple"],
  ["wht", "White"],
]

const PADDLE_SHAPE_VARIANTS = [
  ["circle", "Circle"],
  ["square", "Square"],
  ["stars", "Stars"],
  ["diamond", "Diamond"],
]

const SHAPES = [
  ["airports", "Airport", "A"],
  ["heliport", "Heliport", "H"],
  ["flag", "Flag", "F"],
  ["target", "Target", "T"],
  ["info", "Info", "I"],
  ["info-i_maps", "Info i", "I"],
  ["camera", "Camera", "C"],
  ["caution", "Caution", "!"],
  ["campfire", "Campfire", "C"],
  ["ferry", "Ferry", "F"],
  ["gas_stations", "Fuel", "G"],
  ["hiker", "Hiker", "H"],
  ["horsebackriding", "Horse Riding", "H"],
  ["lodging", "Lodging", "L"],
  ["parking_lot", "Parking", "P"],
  ["parks", "Parks", "P"],
  ["phone", "Phone", "P"],
  ["picnic", "Picnic", "P"],
  ["poi", "POI", "•"],
  ["police", "Police", "P"],
  ["rail", "Rail", "R"],
  ["sailing", "Sailing", "S"],
  ["shaded_dot", "Shaded Dot", "•"],
  ["shopping", "Shopping", "S"],
  ["snack_bar", "Snack", "S"],
  ["swimming", "Swimming", "S"],
  ["toilets", "Toilets", "T"],
  ["volcano", "Volcano", "V"],
  ["webcam", "Webcam", "W"],
  ["play", "Play", "▶"],
  ["triangle", "Triangle", "▲"],
  ["dollar", "Dollar", "$"],
  ["star", "Star", "★"],
]

const paddleIcons = PADDLE_COLOR_VARIANTS.flatMap(([colorKey, colorLabel]) =>
  PADDLE_SHAPE_VARIANTS.map(([shapeKey, shapeLabel]) => ({
    label: `${colorLabel} ${shapeLabel}`,
    url: `https://maps.google.com/mapfiles/kml/paddle/${colorKey}-${shapeKey}.png`,
    symbol: colorLabel[0],
  })),
)

const shapeIcons = SHAPES.map(([key, label, symbol]) => ({
  label,
  url: `https://maps.google.com/mapfiles/kml/shapes/${key}.png`,
  symbol,
}))

const FORE_FLIGHT_UNSUPPORTED_INDEXES = new Set([
  33, 34, 35,
  37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62,
  64, 65,
])

const allIcons = [...paddleIcons, ...shapeIcons]

export const GOOGLE_KML_ICONS = allIcons.filter((icon, idx) => {
  const oneBased = idx + 1
  if (FORE_FLIGHT_UNSUPPORTED_INDEXES.has(oneBased)) return false
  if (/-stars\.png$/i.test(icon.url)) return false
  return true
})
